import { useApi } from "../useApi";

export const useDueDiligenceFeedback = () => {
  const {
    getDueDiligenceFeedbackQuestionsEndpoint,
    getDueDiligenceFeedbackStatusEndpoint,
    submitDueDiligenceFeedbackEndpoint,
    dismissDueDiligenceFeedbackPromptEndpoint,
  } = useApi();

  const getFeedbackQuestions = async () => {
    return await getDueDiligenceFeedbackQuestionsEndpoint();
  };

  const getFeedbackStatus = async (caseId: string) => {
    return await getDueDiligenceFeedbackStatusEndpoint(caseId);
  };

  const submitFeedback = async (
    caseId: string,
    data: { npsScore: number; answers: Record<string, string> }
  ) => {
    return await submitDueDiligenceFeedbackEndpoint(caseId, data);
  };

  const dismissFeedbackPrompt = async () => {
    return await dismissDueDiligenceFeedbackPromptEndpoint();
  };

  return {
    getFeedbackQuestions,
    getFeedbackStatus,
    submitFeedback,
    dismissFeedbackPrompt,
  };
};
